// @ts-nocheck
/* eslint-disable */

"use client";

import { Suspense } from "react";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import styled from "styled-components";
import { variables } from "politicamente-informados-ds";

const ChatTema = (post: Record<string, unknown>) => {
  return (
    <Suspense>
      {!!post?.blocks?.length &&
        post?.blocks?.map((block: BlocksProps, index: number) => {
          return displayBlock(block, index);
        })}
      <StyledInputs>
        {!!post?.reusableBlocks?.length &&
          post?.reusableBlocks?.map((block: BlocksProps, index: number) => {
            return displayBlock(block, index);
          })}
      </StyledInputs>
    </Suspense>
  );
};
export default ChatTema;

const StyledInputs = styled.div`
  input {
    label {
      color: ${variables.colors.white};
    }
  }
`;
